export default __webpack_public_path__ + "static/media/logo.bb48f71f.png";